/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { api } from "../api/httpClient";
import {
  IResponseShowUserPreferences,
  IUserPreference,
} from "@/interfaces/userPreference";

const BASE_ME = "/users/me/user_preferences";
const BASE = "/user_preferences";

export async function showUserPreference({ key }: { key: string }) {
  const { data } = await api.post<IResponseShowUserPreferences>(BASE_ME, { key });
  return data;
}

export async function createUserPreference({
  userPreference,
}: {
  userPreference: IUserPreference;
}) {
  const { data } = await api.post<IResponseShowUserPreferences>(BASE, {
    userPreference,
  });
  return data;
}
